import React from 'react';
import PrivateRoute from '../../routes/privateRoute';
import {Path} from './constants/config'

const DocumentManagement = React.lazy(() => import('./views/DocumentManagement'));
const RecycleBin = React.lazy(() => import('./views/RecycleBin'));
const DocumentDetail = React.lazy(() => import('./views/components/DocumentDetail/DocumentDetail'));
const DocumentDownloadLink = React.lazy(() => import('./views/DocumentDownloadLink'));

const documentRoutes = {
    path: Path.Document,
    name: 'Documents',
    icon: 'dripicons-copy',
    route: PrivateRoute,
    children: [
    {
        path: Path.DocumentManagement,
        name: 'Document Management',
        component: DocumentManagement,
        show: true,
        permissions: [{name: ['Document.ReadOnly']}, {name: ['Document.FullControl']}],
        route: PrivateRoute,
    }, {
        path: Path.RecycleBin,
        name: 'Recycle Bin',
        component: RecycleBin,
        show: true,
        permissions: [{name: ['Document.ReadOnly']}, {name: ['Document.FullControl']}],
        route: PrivateRoute,
    }, {
        path: Path.DocumentDetail,
        name: 'Detail Document',
        component: DocumentDetail,
        show: false,
        route: PrivateRoute,
    }, {
        path: Path.ChildDocument,
        name: 'Child Document',
        component: DocumentDetail,
        show: false,
        route: PrivateRoute,
    }, {
        path: Path.DocumentDownload,
        name: 'Document Download',
        component: DocumentDownloadLink,
        show: false,
        route: PrivateRoute,
    }],
};

export default documentRoutes;
